import { Rating } from '../../components/Rating';
import { useGeneralInfo } from '../../hooks';

export function RatingContainer() {
  const { dailyRating } = useGeneralInfo();

  if (!dailyRating) {
    return null;
  }

  const { rating, reviewsCount } = dailyRating;

  return <Rating rating={rating} reviewsCount={reviewsCount} />;
}
